/** The governors banner photo (a versioned address, or null when there's no photo), set when the list loads. */
let hero = null;
export const setGovernorsHero = url => hero = url || null;
export const governorsHero = () => hero;
flarum.reg.add('voucha-community', 'common/governorsHero', { setGovernorsHero: setGovernorsHero,governorsHero: governorsHero, });